import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.json'
import es from './es.json'

Vue.use(VueI18n)

const messages = { en, es }

const savedLocale = localStorage.getItem('locale-fe') || 'es';

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages
})

export default i18n
